import { ChangeEvent, FC } from "react"
import { useAppDispatch, useAppSelector } from "@/store"
import {
  DevToolsSelectors,
  ITmaOverride,
  setTmaOverride
} from "@/store/slices/devTools"
import styles from "./EmulateEnvironmentSection.module.scss"

const OPTIONS: { value: ITmaOverride; label: string }[] = [
  { value: "auto", label: "Auto" },
  { value: "tma", label: "TMA" },
  { value: "browser", label: "Browser" }
]

export const EmulateEnvironmentSection: FC = () => {
  const dispatch = useAppDispatch()
  const tmaOverride = useAppSelector(DevToolsSelectors.selectTmaOverride())

  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const next = e.target.value as ITmaOverride
    dispatch(setTmaOverride(next))
    window.location.reload()
  }

  return (
    <section className={styles.EmulateEnvironmentSection}>
      <h3 className={styles.EmulateEnvironmentSection_title}>Environment</h3>
      <label className={styles.EmulateEnvironmentSection_row}>
        <span className={styles.EmulateEnvironmentSection_label}>
          Emulate environment
        </span>
        <select
          className={styles.EmulateEnvironmentSection_select}
          value={tmaOverride}
          onChange={handleChange}
        >
          {OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </label>
    </section>
  )
}
